import FeatherIcon from "feather-icons-react";

import ManIcon from "../../Assets/Images/html5-templates/man.png";
import BadgeLogo from "../../Assets/Images/html5-templates/badgelogo.png";

const EcommercePackshotPreview = (props: any) => {
  const {
    showBadge,
    title_font_color,
    subtitle_font_color,
    close_btn_bg_color,
    close_btn_fg_color,
    cta_btn_bg_color,
    cta_btn_font_color,
    title_text,
    sub_title_text,
    cta_btn_text,
    link_url,
    bgImageLink,
    logoImageLink,
    mainImageVideoLink,
    ctaBtnIcnLink,
    badgeImgLink,
  } = props.templateProperties;

  return (
    <>
      <div
        className="bannerGenerat"
        style={
          bgImageLink
            ? { backgroundImage: `url(${bgImageLink})` }
            : { backgroundColor: "#a6a6a6" }
        }
      >
        <a
          href={link_url ? link_url : ""}
          target="_blank"
          rel="noreferrer"
          className="overlayLink"
        >
          &nbsp;
        </a>
        <span
          className="closeBtn"
          style={{
            backgroundColor: close_btn_bg_color
              ? close_btn_bg_color
              : "#a5c7db",
            color: close_btn_fg_color ? close_btn_fg_color : "#fff",
          }}
        >
          +
        </span>

        <div
          className="logo"
          style={
            logoImageLink
              ? {
                  backgroundImage: `url(${logoImageLink})`,
                  padding: "5px 10px",
                }
              : {
                  backgroundColor: "#a5c7db",
                  color: "#000",
                  padding: "5px 10px",
                }
          }
        >
          {logoImageLink ? "" : "LOGO"}
        </div>
        <h2
          style={{
            color: title_font_color,
            fontSize: "22px",
            marginBottom: "5px",
          }}
        >
          {title_text ? title_text : "Title XXX"}
        </h2>
        <p
          style={{
            color: subtitle_font_color,
            fontSize: "18px",
            fontWeight: "500",
            marginBottom: "10px",
          }}
        >
          {sub_title_text ? sub_title_text : "subtitle XXX XXX"}
        </p>

        <div className="imgbox">
          <img
            src={mainImageVideoLink ? mainImageVideoLink : ManIcon}
            alt="img"
            className="mainImg"
          />
          {showBadge && (
            <img
              src={badgeImgLink ? badgeImgLink : BadgeLogo}
              alt="img"
              className="badgeLogo"
            />
          )}

          <div
            className="ctacart"
            style={{
              backgroundColor: cta_btn_bg_color ? cta_btn_bg_color : "#a5c7db",
              //textTransform: "uppercase",
              fontSize: "16px",
              color: cta_btn_font_color ? cta_btn_font_color : "#000",
            }}
          >
            <span
              className="icon"
              style={{
                color: cta_btn_font_color ? cta_btn_font_color : "#000",
                border: `1px solid ${
                  cta_btn_font_color ? cta_btn_font_color : "#000"
                }`,
              }}
            >
              {" "}
              {ctaBtnIcnLink ? (
                <img src={ctaBtnIcnLink} alt="" width={15} height={15} />
              ) : (
                <FeatherIcon icon="shopping-cart" />
              )}{" "}
            </span>
            {cta_btn_text ? cta_btn_text : "CTA"}
          </div>
        </div>
      </div>
    </>
  );
};

export default EcommercePackshotPreview;
